import styled from "styled-components";
import { HomepageHeaderArenaBadgeDefaultBox } from "./home-page-header-arena-badge.default.box";
import { baseColors} from '../../../../themes/definitions/si/base-colors';

export const HomepageHeaderArenaBadgeSIBox = styled(HomepageHeaderArenaBadgeDefaultBox)`
  font-size: 1.8rem;
  background-color: ${baseColors.base03Dark};
  padding: 0 0.7rem;
  box-shadow: 0 0 1px 1px ${props => props.theme.colors.background};
  border-radius: 0.5rem;
  transform: translate(50%, 10px);
  z-index: 1;
`;
